module.exports = __webpack_public_path__ + "static/img/circleGreen.997bfc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/circleGreen.png
// module id = kzLN
// module chunks = 1